<template lang="pug">
  v-layout.column.justify-end.align-end.fill-height
    v-chip.mb-2
      strong.mr-2 Total gravado:  
      span(:v-html='Datos.total_gravada = toNumber( Datos.items.map( item => (item.tipo_de_igv === 1) ?  Number(item.cantidad) * Number(item.valor_unitario) : 0).reduce((a, b) =>  a + b, 0 ) )' )  {{Datos.total_gravada}}
    v-chip.mb-2
      strong.mr-2 Total exonerado:  
      span(:v-html='Datos.total_exonerada = toNumber( Datos.items.map( item => (item.tipo_de_igv === 8) ?  Number(item.cantidad) * Number(item.valor_unitario) : 0).reduce((a, b) =>  a + b, 0 ) )' )  {{ Datos.total_exonerada }}
    v-chip.mb-2
      strong.mr-2 Descuento:  
      span(:v-html=' Datos.total_descuento = toNumber( Datos.items.map( item=> item.descuento ).reduce((a, b) =>  a + b, 0 ) ) ') {{ Datos.total_descuento }}
      span(:v-html='Datos.descuento_global = toNumber( Datos.items.map( item=> item.descuento ).reduce((a, b) =>  a + b, 0 ) )') 
    v-chip.mb-2
      strong.mr-2 IGV:
      span(v-html='Datos.total_igv = toNumber( Datos.items.map( item => item.tipo_de_igv === 1  ? [ Number(item.valor_unitario) * Number(item.cantidad) - item.descuento ] * 0.18 : 0 ).reduce((a, b) =>  a + b, 0 ) )') {{ Datos.total_igv }}
    v-chip.mb-2
      strong.mr-2 Total: 
      span(:v-html='Datos.total = toNumber(Datos.items.map( item => item.tipo_de_igv === 1 ? [ Number(item.cantidad) * Number(item.valor_unitario) - item.descuento ] * 1.18 : Number(item.cantidad) * Number(item.valor_unitario) - item.descuento ).reduce((a, b) =>  a + b, 0))') {{ Datos.total }}
</template>
<script>

import {mapState} from 'vuex'
export default {
  computed:{
    Modelo() { return this.$store.state[this.modelo] },
    Datos() { return this.$store.state[this.modelo].data },
    Rules() { return this.$store.state.Helpers.rules}
  },
  props: {
    modelo: String
  },
  
}
</script>

